export class linkUserModel {
  client_id: string;
  patient_id: string;
  practice_id: string;
  cell_phone: string;
  date_of_birth: string;
  username: string;
  password: string;
}
